import React, { useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import { EMPLOYEE_NAV } from "./_nav";
import { api, errFrom } from "../../lib/api";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/ui/tabs";
import MultiImageCard from "../../components/MultiImageCard";
import { toast } from "sonner";

export default function EmployeeUploads() {
  const [tags, setTags] = useState([]);
  const [inspections, setInspections] = useState([]);

  useEffect(() => {
    api.get("/employee/my-uploads").then(({ data }) => {
      setTags(data.dealership_tags);
      setInspections(data.customer_inspections);
    }).catch((e) => toast.error(errFrom(e)));
  }, []);

  return (
    <AppShell nav={EMPLOYEE_NAV} title="My Uploads" subtitle="Everything you've posted">
      <Tabs defaultValue="tags">
        <TabsList className="bg-[#0A0A0A] border border-white/10 h-11">
          <TabsTrigger value="tags" className="data-[state=active]:bg-[#FF3B30] data-[state=active]:text-white px-6" data-testid="uploads-tab-tags">Dealership tags ({tags.length})</TabsTrigger>
          <TabsTrigger value="insp" className="data-[state=active]:bg-[#FF3B30] data-[state=active]:text-white px-6" data-testid="uploads-tab-inspections">Customer cars ({inspections.length})</TabsTrigger>
        </TabsList>
        <TabsContent value="tags" className="mt-6">
          <Gallery items={tags} renderMeta={(t) => (
            <>
              <div className="text-sm font-semibold truncate">{t.dealership_name}</div>
              <div className="text-[11px] text-zinc-500">{new Date(t.created_at).toLocaleString()}</div>
            </>
          )} />
        </TabsContent>
        <TabsContent value="insp" className="mt-6">
          <Gallery items={inspections} renderMeta={(i) => (
            <>
              <div className="text-sm font-semibold truncate">{i.customer_name}</div>
              <div className="text-[11px] text-zinc-500">{new Date(i.created_at).toLocaleString()}</div>
            </>
          )} />
        </TabsContent>
      </Tabs>
    </AppShell>
  );
}

function Gallery({ items, renderMeta }) {
  if (!items.length) return <div className="brand-surface rounded-2xl p-12 text-center text-zinc-500">No uploads yet.</div>;
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      {items.map((it) => (
        <MultiImageCard key={it.id} item={it} testId={`gallery-item-${it.id}`}>
          {renderMeta(it)}
        </MultiImageCard>
      ))}
    </div>
  );
}
